<template>
  <!-- 流水数据 -->
  <div class="water-data">
    <HeadControl ref="HeadControl" :titleName="'流水数据'" :showorg="false" @changePicker="changePicker" @changDate="changDate"></HeadControl>
    <div class="inner-top">
      <div class="left">
        <div class="left-t" v-for="(item, index) in summaryList" :key="index">
          <div class="icon">
            <img :src="item.itemIcon" />
          </div>
          <div class="desc">
            <div class="a-title">{{item.itemName}}</div>
            <div class="amount">{{aFormat(item.amount)}}<span>元</span></div>
          </div>
        </div>
      </div>
      <div class="right">
        <div ref="currentTrend" style="height: 100%"></div>
      </div>
    </div>
    <div class="inner-bottom">
      <div class="left">
        <div class="left-t">
          <div class="a-titel">收款类型</div>
          <div class="count">
            <div class="count-inner" v-for="(item, index) in summaryTypeList" :key="index">
              <div class="l-box">
                <div class="l-t">{{item.itemName}}</div>
                <div class="l-a">{{aFormat(item.amount)}}<span>元</span></div>
                <div class="l-t">{{item.count}}笔</div>
              </div>
              <div class="r-box">
                <img :src="item.itemIcon" />
              </div>
            </div>
          </div>
        </div>
        <div class="left-b">
          <div ref="proportion" style="height: 100%"></div>
        </div>
      </div>
      <div class="right">
        <div ref="paymenttype" style="height: 100%"></div>
      </div>
    </div>
  </div>
</template>

<script>
import * as Urls from '@/helper/Urls';
import HeadControl from "@/components/HeadControl";
import {EchartsformatDate, amountFormat, floatDiv, checkDay, subStringNum, floatWidth} from '@/helper/VueHelper';

export default {
  components: {
    HeadControl,
  },
  data() {
    return {
      screenWidth: document.body.clientWidth, // 屏幕宽度
      isH5: false,
      dataRange: [],
      summaryList: {},
      currentTrendList: {},
      summaryTypeList: {},
      proportionList: {},
      paymentTypeList: {},
    }
  },
  mounted() {
    if (this.$route.query.identification) {
      this.isH5 = true;
    }
    window.onresize = () => {
      return (() => {
        window.screenWidth = document.body.clientWidth; //实时宽度
        this.screenWidth = window.screenWidth;
      })();
    }; 
  },
  methods: {
    init() {
      this.$refs.HeadControl.getDatas('month');
    },
    changePicker(data) {
      this.dataRange = data;
      this.getSummaryData();
      this.getTrendData();
      this.getSummaryType();
      this.getProportionData();
      this.getPaymentType();
    },
    changDate(data) {
      this.dataRange = data;
      this.getSummaryData();
      this.getTrendData();
      this.getSummaryType();
      this.getProportionData();
      this.getPaymentType();  
    },
    aFormat(amount) {
      return amountFormat(amount);
    },
    //汇总(收款流水、支出流水)
    getSummaryData() {
      let url = Urls.getEchartsSummaryFinanceIncomeReportItemData;
      let params = {
        startTime: this.dataRange.length ? this.dataRange[0] : "",
        endTime: this.dataRange.length ? this.dataRange[1] : "",
      };
      this.$root.doPost(url, params, (server_data) => {
        // 用户没有登录
        if (!this.$root.isUserLogin(server_data)) {
          return;
        }

        // 应用错误
        if (server_data.error) {
          this.$root.showGlobalError(server_data.error);
          return;
        }
        this.summaryList = server_data.data.series;
      });
    },
    // 流水走势
    initCurrentTrendChart() {
      this.currentTrendChart = this.$echarts.init(this.$refs.currentTrend, {width: 'auto'});
      let {legend, series, xAxis} = this.currentTrendList;
      let maxAmount = Math.max(...series[0].data, ...series[1].data);
      const option = {
        textStyle: {
          fontFamily: 'PingFang-M'
        },
        title: {
          text: "流水走势",
          top: "24",
          left: this.isH5 ? "15" : "30",
          textStyle: {
            fontWeight: 500,
            // fontFamily: 'PingFang-M'
          }
        },
        grid: {
          left: floatWidth(maxAmount, 9) + 25,
          right: this.isH5 ? '15' : "40",
          top: "100",
          bottom: "50",
          // containLabel: true,
        },
        tooltip: {
          show: true,
          trigger: "axis",
          formatter: function (params) {
            let h = `<div style="padding: 5px 10px; font-size: 12px">`;
            params.forEach(item => {
              if (item.seriesIndex == 0) {
                h += `<div >${EchartsformatDate(item.axisValue)}</div>
                        <div><div>${item.marker}${item.seriesName}：${amountFormat(item.value)}元</div>
                      `
              } else {
                if (params.length == 1) {
                  h += `<div >${EchartsformatDate(item.axisValue)}</div>`
                }
                h += `<div>${item.marker}${item.seriesName}：${amountFormat(item.value)}元</div></div>`
              }
            });

            return h;
          },
          axisPointer: {
              lineStyle: {
                  color: '#DDDDDD',
                  type:'solid'
              },
          },
        },
        legend: {
          show: true,
          x: this.isH5 ? 150 : 200,
          y: "26",
          icon: "circle",
          itemGap: 25,
          itemWidth: 8,
          itemHeight: 8,
          textStyle: {
            color: "#646464",
            height: 10,
            rich: {
              a: {
                verticalAlign: "middle",
              },
            },
          },
          data: legend,
        },
        xAxis: [
          {
            type: "category",
            boundaryGap: 0,
            axisLine: {
              show: Math.max(...series[0].data, ...series[1].data) == 0 ? true : false,
              lineStyle: {
                color: '#dddddd'
              }
            },
            axisLabel: {
              show: this.isH5 ? false : true,
              color: "#666666",
              interval: this.screenWidth <= 1366 || checkDay(this.dataRange) < 30 ? 'auto' : Math.ceil(xAxis.data.length / 10),
              // padding: [15, 0, 15, 0],
              margin: 15
            },
            splitLine: {
              show: Math.max(...series[0].data, ...series[1].data) == 0 ? false : true,
              lineStyle: {
                color: '#dddddd'
              }
            },
            axisTick: {
              show: false,
            },
            data: xAxis.data,
          },
        ],
        yAxis: [
          {
            type: "value",
            name: "金额(万)",
            min: 0,
            max: maxAmount,
            splitNumber: 5,
            interval: maxAmount < 0.05 * 10000 ? maxAmount : maxAmount / 5,
            show: Math.max(...series[0].data, ...series[1].data) == 0 ? false : true,
            splitLine: {
              show: Math.max(...series[0].data, ...series[1].data) == 0 ? false : true,
              lineStyle: {
                color: "#dddddd",
                type: "solid",
              },
            },
            axisLine: {
              show: false,
            },
            axisLabel: {
              show: true,
              // padding:[2,2,2,2],
              color: "#666666",
              formatter: (params) => {
                let res = floatDiv(params, 10000);
                res.toFixed(2);
                return Math.max(...series[0].data, ...series[1].data) == 0 ? params : (params == 0 ? 0 : subStringNum(res, 2));
              }
            },
            axisTick: {
              show: false,
            },
            // 坐标轴名称的文字样式
            nameTextStyle: {
              padding: [0, 0, 0, -20],
              color: "#666666",
            },
          },
        ],
        series: [
          {
            name: series[0].name,
            type: "line",
            smooth: true,
            symbolSize: 2,
            showSymbol: false,
            itemStyle: {
              normal: {
                opacity: Math.max(...series[0].data, ...series[1].data) == 0 ? 0 : 1,
                color: "#5ebbff",
                lineStyle: {
                  color: "#5ebbff", 
                  width: 2,
                  opacity: Math.max(...series[0].data, ...series[1].data) == 0 ? 0 : 1,
                },
              },
            },
            areaStyle: {
              normal: {
                color: "#e6f5ff",
                // opacity: 0.2
              },
            },
            data: series[0].data,
          },
          {
            name: series[1].name,
            type: "line",
            smooth: true,
            stack: "总量",
            symbolSize: 2,
            showSymbol: false,
            itemStyle: {
              normal: {
                opacity: Math.max(...series[0].data, ...series[1].data) == 0 ? 0 : 1,
                color: "#72d8c0",
                lineStyle: {
                  color: "#72d8c0", 
                  width: 2,
                  opacity: Math.max(...series[0].data, ...series[1].data) == 0 ? 0 : 1,
                },
              },
            },
            areaStyle: {
              normal: {
                color: "#cdedf2",
                // opacity: 0.2
              },
            },
            data: series[1].data,
          },
        ],
      };
      this.currentTrendChart.setOption(option);
      window.addEventListener("resize", () => {
        this.isH5 ? this.currentTrendChart.resize({width: this.screenWidth - 24}) : this.currentTrendChart.resize();
      });
      this.isH5 ? this.currentTrendChart.resize({width: this.screenWidth - 24}) : this.currentTrendChart.resize();
    },
    getTrendData() {
      let url = Urls.getEchartsTrendFinanceIncomeData;
      let params = {
        startTime: this.dataRange.length ? this.dataRange[0] : "",
        endTime: this.dataRange.length ? this.dataRange[1] : "",
      };
      this.$root.doPost(url, params, (server_data) => {
        // 用户没有登录
        if (!this.$root.isUserLogin(server_data)) {
          return;
        }

        // 应用错误
        if (server_data.error) {
          this.$root.showGlobalError(server_data.error);
          return;
        }
        this.currentTrendList = server_data.data;
        this.initCurrentTrendChart();
      });
    },
    // 收款类型
    getSummaryType() {
      let url = Urls.getEchartsSummaryFinanceIncomeTypeReportItemData;
      let params = {
        startTime: this.dataRange.length ? this.dataRange[0] : "",
        endTime: this.dataRange.length ? this.dataRange[1] : "",
      };
      this.$root.doPost(url, params, (server_data) => {
        // 用户没有登录
        if (!this.$root.isUserLogin(server_data)) {
          return;
        }

        // 应用错误
        if (server_data.error) {
          this.$root.showGlobalError(server_data.error);
          return;
        }
        this.summaryTypeList = server_data.data.series;
      });
    },
    //  进度条 已认领收款占比    
    initProportionChart() {
    this.proportionChart = this.$echarts.init(this.$refs.proportion, {width: 'auto'});
    let {series, yAxis} = this.proportionList;
    const option = {
        textStyle: {
          fontFamily: 'PingFang-M'
        },
        title: {
          text: '已认领收款占比',
          top: "24",
          left: this.isH5 ? "15" : "30",
          textStyle: {
            fontWeight: 500
          }
        },            
        grid: {
            left: this.isH5 ? '15' : "40",
            right: this.isH5 ? '15' : "40",
            bottom: 10,
            top: 60,
        },
        tooltip: {
          trigger: 'item',
          formatter:(params) => {
            console.log(params)
            return `<div style="font-size:14px; padding:4px;">
                         <div>${params.name}： ${series[0].data[params.dataIndex]}笔</div>
                         <div>金额：${amountFormat(series[0].amountData[params.dataIndex])}元</div>
                         <div>占比：${series[0].percent[params.dataIndex]}%</div>
                     </div>`
          }
        },
        xAxis: {
            show: false,
            type: 'value'
        },
        yAxis: [{
            type: 'category',
            inverse: true,       
            axisLabel: {
                formatter: (val,index)=>{
                    return val + ` （${series[0].data[index]}笔）`
                },
                textStyle: {
                    color: '#666666',
                    fontSize: '14',
                    lineHeight:20,
                },
                padding:[0,0,35,10],
                align:'left',
                rich: {}
            },
            splitLine: {
                show: false
            },
            axisTick: {
                show: false
            },
            axisLine: {
                show: false
            },
            data: yAxis.data
            }, {
                type: 'category',
                inverse: true,
                axisTick: 'none',
                axisLine: 'none',
                position:'left',
                show: true,
                axisLabel: {
                    textStyle: {
                        color: '#57b9ff',
                        fontSize: 14
                    },
                    padding:[-20,0,-60,10],
                    formatter: function(val, index){
                      return `{color|${amountFormat(series[0].amountData[index])}元} \xa0（${val}%）`
                    },
                    align:'left',
                    rich: {
                      color: {
                        color: '#333',
                        fontSize: 14,
                      }
                    }
                },
                data: series[0].percent
            },
        ],
        series: [{
                type: 'bar',
                zlevel: 1,
                // silent: true,
                itemStyle: {
                    normal: {
                        barBorderRadius: 10,
                        color: '#57b9ff'
                    },
                },
                barWidth: 10,
                data: series[0].percent,
            },
            {
                name: '背景',
                type: 'bar',
                silent: true,
                barWidth: 10,
                barGap: '-100%',
                data: [100, 100, 100],
                itemStyle: {
                    normal: {
                        color: '#dddddd',
                        barBorderRadius: 10,
                    }
                },
            },
            
          ]
        };
        this.proportionChart.setOption(option);
        window.addEventListener("resize", () => {
          this.isH5 ? this.proportionChart.resize({width: this.screenWidth - 24}) : this.proportionChart.resize();
        });
        this.isH5 ? this.proportionChart.resize({width: this.screenWidth - 24}) : this.proportionChart.resize();
    },
    getProportionData() {
      let url = Urls.getEchartsClaimedFinanceIncomeTypeReportItemData;
      let params = {
        startTime: this.dataRange.length ? this.dataRange[0] : "",
        endTime: this.dataRange.length ? this.dataRange[1] : "",
      };
      this.$root.doPost(url, params, (server_data) => {
        // 用户没有登录
        if (!this.$root.isUserLogin(server_data)) {
          return;
        }

        // 应用错误
        if (server_data.error) {
          this.$root.showGlobalError(server_data.error);
          return;
        }
        this.proportionList = server_data.data;
        this.initProportionChart();
      });
    },
    // 付款类型
    initPaymentTypeChart() {
      let widthPx = this.screenWidth
      this.paymentTypeChart = this.$echarts.init(this.$refs.paymenttype, {width: 'auto'});
      let {amount, legend, max, series, xAxis} = this.paymentTypeList;
      let maxPercent = Math.ceil(Math.max(...series[0].data) / 10) * 10;
      let maxAmount = Math.ceil(Math.max(...series[1].data));
      const option = {
        textStyle: {
          fontFamily: 'PingFang-M'
        },
        title: {
          text: '付款类型',
          top: "24",
          left: this.isH5 ? "15" : "30",
          // padding:[24,0,0,30],
          textStyle: {
            fontWeight: 500
          }
        },
        grid: { 
          left: this.isH5 ? '15' : '40',
          right: this.isH5 ? '15' : '40',
          bottom: '20px',
          top:'100px',
          containLabel: true
        },
        opacity:0.1,       
        tooltip: {
          trigger: 'axis',
          formatter:function(params){
            let h = `<div style="padding: 0 10px; font-size: 12px">`;
            params.reverse().forEach(item => {
              if (item.seriesIndex == 1) {
                h += `
                    <div>${item.name}</div>
                    <div>金额：${amountFormat(item.data)}元</div>
                  `;
              } else {
                h += `<div>占比：${item.data}%</div></div>`
              }
            });

            return h;
          }
        },
        legend: {
          data: legend,
          itemWidth: 30,// 单个icon的width（单位px）
          itemHeight: 8,// 单个icon的height（单位px）
          itemGap: 20,// 每个icon之间的距离（单位px）
          x: this.isH5 ? 150 : 200,
          y: "26",
          textStyle: {
              fontSize: '12',
              color: '#666666',    
              height: 10,
                rich: {
                a: {
                  verticalAlign: 'middle',
              },
            }
          },                  
        },
        xAxis: [
          {
            type: 'category',
            offset:5,
            data: xAxis.data,
            axisPointer: {
              type: 'shadow'
            },
            // 分隔线
            splitLine: {
              show: Math.max(...series[0].data) == 0 ? false : true,
              lineStyle: {
                color: '#dddddd'
              },
            },
            axisTick:{
              show:false,
            },  
            axisLine:{
              show: true,
              lineStyle: {
                color: '#dddddd'
              },
            },     
            axisPointer: {
              type: 'none'
            },
            axisLabel: {
              color: '#666666',
              // interval: 0,
              // rotate: this.isH5 || this.screenWidth <= 1366 ? 30 : 0,
              // fontSize: this.isH5 ? 10 : 12
              formatter:(params)=>{
                if(widthPx <= 1366 || widthPx == 1536 ){
                  let newParamsName = "";
                  let paramsNameNumber = params.length;
                  let provideNumber = this.isH5 ? 2 : 3;  
                  let rowNumber = Math.ceil(paramsNameNumber / provideNumber);
                  if (paramsNameNumber > provideNumber) {
                    for (let p = 0; p < rowNumber; p++) {
                      let tempStr = "";
                      let start = p * provideNumber;
                      let end = start + provideNumber;
                      if (p == rowNumber - 1) {
                        tempStr = params.substring(start, paramsNameNumber);
                      } else {
                        tempStr = params.substring(start, end) + "\n";
                      }
                      newParamsName += tempStr;
                    }
                  } else {
                    newParamsName = params;
                  }
                  return newParamsName;
                }else{
                  return params
                }
              }
            }                             
          }
        ],
        yAxis: [
          {
            // 数据显示
            offset:5,
            type: 'value',
            name: '百分比',
            min: 0,
            max: maxPercent,
            splitNumber: 5,
            interval: maxPercent / 5,
            axisLabel: {
              color: '#666666',
              formatter: '{value}%'
            },
            // 分隔线
            splitLine: {
              show: true,
                lineStyle: {
                color: '#dddddd'
                },
            },
            // 坐标轴名称的文字样式
            nameTextStyle: {
              color: '#666666',
              padding: [0,0,0,-30]
            },
            axisTick:{
              show:false
            }, // 刻度
            axisLine:{
              show:false // 轴  
            },
            show: Math.max(...series[0].data) == 0 ? false : true         
          },
          {
            type: 'value',
            name: '金额（万）',
            min: 0,
            max: maxAmount,
            splitNumber: 5,
            interval: maxAmount / 5,
            axisLabel: {
              color: '#666666',
              formatter: params =>{
                let res = floatDiv(params, 10000);
                res.toFixed(2);
                return Math.max(...series[1].data) == 0 ? params : (params == 0 ? 0 : subStringNum(res, 2));
              }
            },
            // 坐标轴名称的文字样式
            nameTextStyle: {
              color: '#666666',
              padding: [0,-20,0,0]
            },
            axisTick:false, // 刻度
            axisLine:{
              show:false // 轴  
            },
            splitLine: {
              show: false
            },
            show: Math.max(...series[0].data) == 0 ? false : true                      
          }
        ],
        series: [
          {
            name: series[0].name,
            type: 'bar',
            // barWidth : this.isH5 ? '30%' : (this.screenWidth <= 1366 ? '40%' : '50%'),
            barWidth : '60%',
            data: series[0].data,
            itemStyle:{
              normal:{
                color: 'rgba(87, 185, 255, 0.35)',
                borderColor: Math.max(...series[0].data) == 0 ? 'rgba(87, 185, 255, 0)' : 'rgba(87, 185, 255, 1)',
                // borderWidth: 2
              }  
            },
          },
          {
            name: series[1].name,
            hoverAnimation: false,
            type: 'line',
            yAxisIndex: "1",
            symbol:'rect',
            symbolSize: 9,
            data: series[1].data,
            itemStyle:{
              emphasis: {          //突出效果配置(鼠标置于拐点上时)
                borderWidth: 3,
                borderColor: '#61d9ac',
                color: '#61d9ac',
              },
              normal:{
                color: '#61D9AC',
                opacity: Math.max(...series[0].data) == 0 ? 0 : 1,
                lineStyle: {
                  opacity: Math.max(...series[0].data) == 0 ? 0 : 1,
                }
              }  
            },
          },
          
        ]
      };
      this.paymentTypeChart.setOption(option);
      window.addEventListener("resize", () => {
        this.isH5 ? this.paymentTypeChart.resize({width: this.screenWidth - 24}) : this.paymentTypeChart.resize();
      });
      this.isH5 ? this.paymentTypeChart.resize({width: this.screenWidth - 24}) : this.paymentTypeChart.resize();
    },
    getPaymentType() {
      let url = Urls.getEchartsFoldOrPostFinanceIncomeData;
      let params = {
        startTime: this.dataRange.length ? this.dataRange[0] : "",
        endTime: this.dataRange.length ? this.dataRange[1] : "",
      };
      this.$root.doPost(url, params, (server_data) => {
        // 用户没有登录
        if (!this.$root.isUserLogin(server_data)) {
          return;
        }

        // 应用错误
        if (server_data.error) {
          this.$root.showGlobalError(server_data.error);
          return;
        }
        this.paymentTypeList = server_data.data;
        this.initPaymentTypeChart();
      });
    },
  },
};
</script>

<style lang="scss">
.water-data {
  .inner-top {
    display: flex;
    margin-top: 0.24rem;
    .left {
      width: calc(30% - 0.6rem - 0.24rem);
      padding: 0 0.3rem;
      margin-right: 0.24rem;
      background: #ffffff;
      box-shadow: 0px 2px 12px 0px rgba(0, 0, 0, 0.1);
      border-radius: 0.1rem;
      .left-t {
        display: flex;
        // justify-content: center;
        align-items: center;
        padding: 0.58rem 0 0.58rem 0.36rem;
        border-bottom: 1px solid #eee;
        .icon {
          width: 0.75rem;
          height: 0.75rem;
          margin-right: 0.35rem;
        }
        .desc {
          .a-title {
            font-size: 0.14rem;
            color: #666666;
            margin-bottom: 0.05rem;
          }
          .amount {
            font-size: 0.26rem;
            color: #333;
            span {
              font-size: 0.14rem;
            }
          }
        }
        &:last-child {
          border-bottom: none;
        }
      }
    }
    .right {
      width: 70%;
      background: #ffffff;
      box-shadow: 0px 2px 12px 0px rgba(0, 0, 0, 0.1);
      border-radius: 0.1rem;
    }
  }
  .inner-bottom {
    width: 100%;
    display: flex;
    margin-top: 0.24rem;
    .left {
      width: calc(50% - 0.12rem);
      margin-right: 0.24rem;
      .left-t {
        padding: 0.24rem 0.3rem;
        background: #ffffff;
        box-shadow: 0px 2px 12px 0px rgba(0, 0, 0, 0.1);
        border-radius: 0.1rem;
        .a-titel {
          font-size: 0.19rem;
          font-weight: 500;
          color: #333333;
        }
        .count {
          display: flex;
          justify-content: space-between;
          align-items: center;
          .count-inner {
            width: calc(50% - 0.33rem);
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin-top: 20px;
            padding-right: 0.33rem;
            border-right: 1px solid #eee;
            &:last-child {
              padding-right: 0;
              border-right: 0;
            }
            .l-box {
              .l-t {
                font-size: 0.14rem;
                color: #666666;
              }
              .l-a {
                font-size: 0.2rem;
                color: #333;
                line-height: 0.4rem;
                span {
                  font-size: 0.14rem;
                }
              }
            }
            .r-box {
              width: 0.55rem;
              height: 0.55rem;
              img {
                width: 0.55rem;
                height: 0.55rem;
              }
            }
          }
        }
      }
      .left-b {
        width: 100%;
        height: 3.5rem;
        background: #fff;
        margin-top: 0.24rem;
        box-shadow: 0px 2px 12px 0px rgba(0, 0, 0, 0.1);
        border-radius: 0.1rem;
      }
    }
    .right {
      width: calc(50% - 0.12rem);
      background: #ffffff;
      box-shadow: 0px 2px 12px 0px rgba(0, 0, 0, 0.1);
      border-radius: 0.1rem;
    }
  }
}
@media screen and (max-width: 1550px) {
  .water-data .inner-top .left .left-t {
    padding: 0.58rem 0 0.58rem 0.1rem;
  }
  .water-data .inner-top .left .left-t .icon {
    width: 0.65rem;
    height: 0.65rem;
    margin-right: 0.2rem;
  }
  .water-data .inner-top .left .left-t .icon img{
    width: 0.65rem;
    height: 0.65rem;
  }
  .water-data .inner-top .left .left-t .desc .amount {
    font-size: 0.18rem;
  }
  .water-data .inner-bottom .left .left-t .count .count-inner {
    width: calc(50% - 0.20rem);
    padding-right: 0.20rem;
  }
  .water-data .inner-bottom .left .left-t .count .count-inner .l-box .l-a {
    font-size: 0.16rem;
  }
}
@media screen and (max-width: 768px) {
  .water-data {
    .inner-top {
      flex-direction: column;
      align-items: center;
      margin-top: -0.05rem;
      .left {
        width: calc(100% - 0.6rem - 0.24rem);
        margin-right: 0;
        .left-t {
          padding: 0.3rem 0 0.3rem 0.1rem;
        }
      }
      .right {
        width: calc(100% - 0.24rem);
        height: 4rem;
        margin-top: 0.12rem;
      }
    }
    .inner-bottom {
      flex-direction: column;
      align-items: center;
      margin-top: 0.12rem;
      .left {
          width: calc(100% - 0.24rem);
          margin-right: 0;
          .left-t {
              padding: 0.24rem;
              .a-titel {
                font-size: 0.18rem;
                font-weight: 500;
              }
             .count {
                align-items: flex-start;
                flex-direction: column;
                .count-inner {
                  width: 100%;
                  border-right: 0;
                  border-bottom: 1px solid #eee;
                  padding-bottom: 0.2rem;
                  padding-right: 0;
                  &:last-child {
                    border-bottom: none;
                    padding-bottom: 0;
                  }
                }
             }
          }
          .left-b {
            margin-top: 0.12rem;
          }
      }
      .right {
        width: calc(100% - 0.24rem);
        height: 5rem;
        margin-top: 0.12rem;
      }
    }
  }
  
}
</style>


// WEBPACK FOOTER //
// waterData.vue?756a236c